import React from 'react'
import SectionHeader from './SectionHeader';
import { LoaderCircle, FileText } from 'lucide-react';
import { cn } from '@univdiam/ui/lib/utils';
type AdditionalInstructionProps = {
  AdditionalInstructions: {
    label: string;
    value: string;
  }[];
  isAdmin: boolean | null;
  handleOpenInstructionForm?: () => void;
  isLoading: boolean;
}

const AdditionalInstruction = ({
  AdditionalInstructions = [], // Added a default empty array as a safety net
  isAdmin,
  handleOpenInstructionForm,
  isLoading
}: AdditionalInstructionProps) => {

  // Cleanly isolate what gets rendered based on the exact state
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className='flex items-center justify-center py-6'>
          <LoaderCircle className='animate-spin text-gray-400 w-6 h-6' />
        </div>
      );
    }

    if (AdditionalInstructions.length === 0) {
      return (
        <div className='flex items-center justify-center py-6'>
          <p>No additional instructions</p>
        </div>
      );
    }

    return AdditionalInstructions.map((instruction, index) => (
      <div key={index} className={cn("grid grid-cols-[30%_70%] text-body2 leading-relaxed gap-4 pr-4")}>
        <span className="text-gray-600 break-all">{instruction.label}</span>
        <span className='font-semibold text-gray-900 break-all'>{instruction.value}</span>
      </div>
    ));
  };

  return (
    <div className='flex flex-col bg-white border border-[#E9EAEB] rounded-md text-caption1 overflow-hidden'>
      <SectionHeader
        title='Additional Instructions'
        sectionIcon={<FileText strokeWidth={1.5} className="w-5 h-5 text-gray-600" />}
        buttonText='Add Instruction'
        isAdmin={isAdmin}
        onButtonClick={handleOpenInstructionForm}
      />
      <div className="p-4 flex flex-col gap-3 text-body2">
        {renderContent()}
      </div>
    </div>
  );
}

export default AdditionalInstruction;